<div id="hours" class="margin-top-10">
    <div class="tableHeader d-flex  ">
        <div class="col-2"> יום </div>
        <div class="col-5"> איסוף </div>
        <div class="col-5"> פיזור </div>
    </div>
    <div [formGroup]="form">
        <ul class="list-group">
            <li *ngFor="let day of days" class="list-group-item d-flex justify-content-center align-items-center">

                <div class="col-2">{{day.viewValue}}</div>
                <div class="col-5">

                    <!-- <select class="select form-control" id="{{day.value}}_e" formControlName="{{day.value}}_e" (change)="onOptionClick()">
                        <option selected></option>
                        <option [ngValue]="hour" *ngFor="let hour of calendarSvc.ScheduleHoursList">{{hour.viewValue}}
                        </option>
                    </select> -->
                    <ng-select formControlName="{{day.value}}_e" [items]="calendarSvc.ScheduleHoursList" bindLabel="viewValue" bindValue="value" notFoundText="לא נמצאו ערכים" (change)="onOptionClick()">
                    </ng-select>
                </div>
                <div class="col-5">
                    <ng-select formControlName="{{day.value}}_p" [items]="calendarSvc.ScheduleHoursList" bindLabel="viewValue" bindValue="value" notFoundText="לא נמצאו ערכים" (change)="onOptionClick()">
                    </ng-select>
                    <!-- <select class="select form-control" id="{{day.value}}_p" formControlName="{{day.value}}_p" (change)="onOptionClick()">
                        <option selected></option>
                        <option [ngValue]="hour" *ngFor="let hour of calendarSvc.ScheduleHoursList">{{hour.viewValue}}
                        </option>
                    </select> -->
                </div>
            </li>
        </ul>
    </div>
</div>